<template>
  <div class="jalali-calendar w-100">
    <!-- Input field -->

    <input
        v-if="!withOutInput"
        class="input-date"
        type="text"
        v-model="formattedDate"
        readonly
        @click="toggleCalendar"
        :placeholder="placeholder"
        v-click-outside="hidePopup"
    />


    <!-- Calendar Popup -->
    <div v-if="isCalendarVisible || withOutInput" class="calendar-popup" :class="{'position-relative':withOutInput}">
      <div class="calendar-header">
        <select v-model="selectedYear" @change="updateCalendar">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <select v-model="selectedMonth" @change="updateCalendar">
          <option v-for="(month, index) in months" :key="index" :value="index + 1">
            {{ month }}
          </option>
        </select>
      </div>

      <!-- Days of the week -->
      <div class="weekdays">
        <div v-for="day in weekDays" :key="day">
          {{ day }}
        </div>
      </div>

      <!-- Calendar Days -->
      <div class="calendar-days">
        <!-- Empty slots for alignment -->
        <div
            v-for="n in firstDayOffset"
            :key="'empty-' + n"
            class="empty-day">
        </div>

        <!-- Days of the month -->
        <div
            v-for="day in daysInMonth"
            :key="day"
            class="day"
            :class="{ 'today': isToday(day) ,'selected' : day === selectedDay && withOutInput }"
            @click="selectDate(day)">
          {{ day }}
        </div>


      </div>
      <div v-if="withOutInput && isNotTodaySelected" class="btns w-100 mt-4">
        <v-btn @click="goToToday" class="btn btn-is-today" variant="text">رفتن به امروز</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: 'calandar_compoenent',
  props: {
    placeholder: {
      type: String,
      default: "تاریخ را انتخاب کنید"
    },
    valueNew: {
      type: String,
      default: null
    },
    withOutInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCalendarVisible: false,
      selectedDate: null,
      selectedDay: '',
      selectedYear: moment().jYear(),
      selectedMonth: moment().jMonth() + 1,
      daysInMonth: [],
      isNotTodaySelected: false,
      firstDayOffset: 0,
      years: Array.from({length: 20}, (_, i) => moment().jYear() - 10 + i),
      months: [
        "فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور",
        "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"
      ],
      weekDays: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
      today: moment(),
    };
  },

  computed: {
    formattedDate() {
      return this.selectedDate
          ? moment(this.selectedDate, "jYYYY/jMM/jDD").format("jYYYY/jMM/jDD")
          : "";
    },
  },
  methods: {
    hidePopup(el) {

      if (el.target.closest('.jalali-calendar') === null) {
        this.isCalendarVisible = false
      }

    },
    goToToday() {
      this.selectedYear = moment().jYear()
      this.selectedMonth = moment().jMonth() + 1
      this.selectDate(this.today.jDate())
      this.selectedDay = ''
    },
    isToday(day) {
      return (
          this.selectedYear === this.today.jYear() &&
          this.selectedMonth === this.today.jMonth() + 1 &&
          day === this.today.jDate()
      );
    },
    toggleCalendar() {
      this.isCalendarVisible = !this.isCalendarVisible;
      this.updateCalendar();
    },
    updateCalendar() {
      this.selectedDay = ''
      const days = moment.jDaysInMonth(this.selectedYear, this.selectedMonth - 1);
      this.daysInMonth = Array.from({length: days}, (_, i) => i + 1);

      // Calculate the first day of the month for alignment
      const firstDay = moment(`${this.selectedYear}/${this.selectedMonth}/1`, "jYYYY/jMM/jDD").day();
      this.firstDayOffset = (firstDay + 1) % 7; // Adjust for Persian week (starting with Saturday)
    },
    selectDate(day) {
      this.selectedDay = day
      this.selectedDate = `${this.selectedYear}/${this.selectedMonth}/${day}`;
      this.isCalendarVisible = false;
      this.$emit("selected", this.selectedDate);
      this.$emit("selected2", this.selectedDate);
      this.$emit('input', this.selectedDate);
      let today = `${this.today.jYear()}/${this.today.jMonth() + 1}/${this.today.jDate()}`

      this.isNotTodaySelected = this.selectedDate !== today


    },
  },
  watch: {
    valueNew(newVal) {
      this.selectedDate = newVal;
      this.formattedDate = newVal;
    }

  },
  mounted() {
    this.updateCalendar();
    this.selectedDate = this.valueNew;
    this.formattedDate = this.valueNew;
  },
};
</script>

<style scoped lang="scss">
.btn-is-today {
  font-size: 12px;
  border: 1px solid #ccc;
}

.jalali-calendar {
  position: relative;
  height: 100%;

  input {
    height: 100%;
    border: 1px solid #EDEEF1;
    border-radius: 99px;
    padding: 10px;
    width: 100%;
  }
}

.calendar-popup {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #D7DBE0;
  padding: 10px;
  z-index: 1000;
  border-radius: 15px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  select {
    width: 50%;
    padding: 5px 10px;
    cursor: pointer;
  }
}

.weekdays {
  margin-bottom: 15px;
}

.weekdays, .calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.weekdays div {
  text-align: center;
  font-weight: bold;
}

.empty-day {
  visibility: hidden;
}

.day {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #6C798B;
  font-size: 12px;
  cursor: pointer;
}

.day:hover {
  background: #f0f0f0;
}

.day.today {
  background: #F07006;
  color: white;
  font-weight: bold;
  border-radius: 15px;
}

.day.selected {
  background: #0020b6;
  color: white;
  font-weight: bold;
  border-radius: 15px;
}
</style>
